<template>
  <div class="home">
    <div class="searchBox">
      <div class="title">IPv6</div>
      <div class="sub_title">Internet Protocol Version 6</div>
      <div class="name">知识与资源共享平台</div>
      <div class="searchInput">
        <el-input v-model="keyWord" size="large" style="max-width: 1120px" placeholder="请输入关键词" @keyup.enter="search">
          <template #append>
            <el-button :icon="Search" type="primary" @click="search">搜索</el-button>
          </template>
        </el-input>
        <div class="searchTagBox" v-if="keyWordList.length">
          <div class="item" @click="searchTag(item)" v-for="(item, index) in keyWordList" :key="index">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="contentBox" :style="{backgroundImage: 'url(/beijingtu/pc.jpg)'}">
      <!-- 数据统计 -->
      <div class="dataStatic data_item">
        <div class="topTitle">{{ ipData.title }}</div>
        
        <div v-html="ipData.content"></div>
        <!-- id="echarts" -->
        <div class="echartsBox">
          <div v-html="echartsData"></div>
        </div>
      </div>

      <!-- 精选文章 -->
      <div class="article data_item">
        <div class="topTitle">精选文章</div>
        <div class="articleBox">
          <div class="left" @click="$toArtetails(selectLeft.id)">
            <el-image v-if="selectLeft.image_input" :src="selectLeft.image_input" class="img"></el-image>
            <div class="title">{{ selectLeft.title }}</div>
          </div>
          <div class="right">
            <div class="item" v-for="(item, index) in selectData" :key="index" @click="$toArtetails(item.id)">
              <el-image v-if="item.image_input" :src="item.image_input" class="image"></el-image>
              <div>
                <div class="titleBox">
                  <!-- <div class="tag">基础知识</div> -->
                  <div class="title">{{ item.title }}</div>
                </div>
                <div class="infoBox">
                  <div class="date">
                    <svg t="1734157326409" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="4338" width="14" height="14">
                      <path
                        d="M511.968002 60.371283c249.052543 0 451.644715 202.62417 451.644716 451.660715 0 249.076541-202.592172 451.676713-451.644716 451.676712-249.044543 0-451.660714-202.600172-451.660714-451.676712 0-249.036544 202.616171-451.660714 451.660714-451.660715m0-60.307288C229.190095 0.063995 0 229.24609 0 512.031998c0 282.769909 229.190095 511.984001 511.968002 511.984001 282.737911 0 511.952004-229.214093 511.952004-511.984001C1023.920006 229.24609 794.705914 0.063995 511.968002 0.063995z"
                        fill="#666666" p-id="4339"></path>
                      <path
                        d="M643.813702 674.419311a29.997656 29.997656 0 0 1-21.318334-8.775314L490.649668 534.262261a30.133646 30.133646 0 0 1-8.863308-21.350332V230.222014c0-16.662698 13.486946-30.157644 30.157644-30.157644s30.149645 13.486946 30.149645 30.157644v270.178892l122.990391 122.542427a30.141645 30.141645 0 0 1-21.270338 51.475978z"
                        fill="#666666" p-id="4340"></path>
                    </svg>
                    {{ $dateFormat(item.createtime) }}
                  </div>
                  <div class="number">
                    <svg t="1734157396802" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="5555" width="14" height="14">
                      <path
                        d="M928.842245 512.091074c0-5.006014-0.846274-9.193383-1.086751-9.691733-0.182149-2.480494-1.028423-7.001461-1.815345-9.374508-0.210801-0.590448-0.484024-1.209548-0.724501-1.799996-0.424672-1.360997-0.876973-2.691295-1.390673-3.749394-76.871785-168.137395-242.376213-281.144168-411.782507-281.144168-169.375595 0-334.865697 112.902396-411.388535 280.130072-0.921999 1.815345-1.572822 3.553942-1.981121 5.066389-0.181125 0.49835-0.39295 0.967024-0.558725 1.406023-1.512447 4.430916-1.542122 7.514137-1.421372 6.712889-0.710175 3.251044-1.360997 9.722432-1.360997 9.722432-0.181125 1.949398-0.181125 3.50687 0.030699 5.442966 0 0 0.649799 5.65479 0.968048 6.80294 0.090051 1.602498 0.483001 3.931542 0.951675 6.048763l-0.030699 0c0.408299 1.814322 0.968048 3.568269 1.738597 5.291516 0.393973 1.330298 0.862647 2.570545 1.270946 3.507894 76.976162 168.166047 242.436588 281.20352 411.781484 281.20352 169.436994 0 334.941422-112.945375 410.936233-279.328823 1.177825-2.177596 1.935072-4.233418 2.448772-6.018064 0.2415-0.543376 0.454348-1.027399 0.604774-1.511423 1.331321-3.872191 1.602498-7.227612 1.481747-7.227612l-0.028653 0.029676C928.027693 520.921183 928.842245 516.89959 928.842245 512.091074zM872.717993 514.146896c-0.029676 0.121773-0.091074 0.272199-0.151449 0.393973-0.090051 0.36225-0.240477 0.785899-0.332575 1.209548-68.403926 147.420561-212.830293 246.337431-360.191502 246.337431-146.997935 0-291.168476-98.642624-360.252901-246.578931-0.166799-0.5137-0.287549-0.998747-0.468674-1.481747-0.030699-0.484024-0.12075-0.876973-0.150426-1.150196-0.060375-0.300852-0.12075-0.724501-0.166799-1.088798l0-0.3776c0.166799-0.620124 0.286526-1.239224 0.347924-1.919722 0.12075-0.36225 0.211824-0.710175 0.347924-1.103124C220.132094 360.89042 364.680235 261.928524 512.041444 261.928524c147.420561 0 291.940049 99.051947 360.161826 246.322082 0.060375 0.287549 0.121773 0.530073 0.212848 0.726547 0.060375 0.2415 0.119727 0.484024 0.240477 0.740874 0.151449 1.104147 0.272199 2.192945 0.423649 2.736321C872.899118 513.028423 872.809067 513.572822 872.717993 514.146896z"
                        fill="#666666" p-id="5556"></path>
                      <path
                        d="M512.041444 373.060601c-76.598562 0-138.954749 62.325487-138.954749 138.939399 0 76.598562 62.356187 138.954749 138.954749 138.954749 76.598562 0 138.954749-62.356187 138.954749-138.954749C650.996193 435.386088 588.640006 373.060601 512.041444 373.060601zM512.041444 595.372849c-45.935192 0-83.371826-37.406958-83.371826-83.371826 0-45.950542 37.436634-83.356476 83.371826-83.356476 45.964868 0 83.373873 37.406958 83.373873 83.356476C595.414293 557.965891 558.006312 595.372849 512.041444 595.372849z"
                        fill="#666666" p-id="5557"></path>
                    </svg>
                    {{ item.visit }}
                  </div>
                </div>
                <div class="content">
                  {{ item.synopsis }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 资源推荐 -->
      <div class="resourceBox data_item">
        <div class="topTitle">资源推荐</div>
        <el-row class="resourceContent" :gutter="20">
          <el-col :span="12" v-for="(item, index) in resouseList" :key="index" @click="$toArtetails(item.id)">
            <div class="item">
              <div class="image" v-if="item.image_input">
                <el-image :src="item.image_input" class="banner"></el-image>
              </div>
              <div class="content">
                <div class="title">{{ item.title }}</div>
                <div class="number">浏览量 <span>{{ item.visit }}</span> </div>
                <div class="date">{{ $dateFormat(item.createtime) }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 实践案例 -->
      <div class="practiceBox data_item">
        <div class="topTitle">实践案例</div>
        <el-row class="practiceContent" :gutter="20">
          <el-col :span="8" v-for="(item, index) in caseList" :key="index" @click="$toArtetails(item.id)">
            <div class="item">
                <el-image v-if="item.image_input" :src="item.image_input" class="image"></el-image>
              <div class="content">
                <div class="title">{{ item.title }}</div>
                <div class="date">{{ $dateFormat(item.createtime) }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { Search } from '@element-plus/icons-vue'
export default {
  data() {
    return {
      Search,
      keyWordList: [],
      keyWord: '',
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          data: ['全球IPv6用户（百万）', '复合年增长率'],
          right: 110
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '行业发展与最新趋势',
            min: 0,
            max: 3000,
            interval: 500,
            axisLabel: {
              formatter: '{value}'
            },
            nameTextStyle: {
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#333333',
              padding: [0, -60, 25, 0]
            }
          },
          {
            type: 'value',
          }
        ],
        series: [
          {
            name: '全球IPv6用户（百万）',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [],
            itemStyle: {
              color: '#246CF9',
              barBorderRadius: [10, 10, 10, 10]
            },
            barWidth: 12,
          },
          {
            name: '复合年增长率',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#FA2256',
            },
            smooth: true,
            symbol: 'none',
            data: []
          }
        ]
      },
      ipData:{},
      resouseList:[],
      caseList:[],
      selectLeft:{},
      selectData:[],
      echartsData:''
    }
  },
  mounted() {
    this.keyWordList = window.localStorage.getItem('keyWordList') ? JSON.parse(window.localStorage.getItem('keyWordList')) : [];
    // this.echartsInit()
    this.getIPv6Data()
    this.getEchartsData()
    this.getResouseListData()
    this.getCaseList()
    this.getSelected()
  },
  methods: {
    echartsInit() {
      this.$echarts.init(document.getElementById('echarts')).setOption(this.options)
    },
    async getIPv6Data(){
      this.ipData = await this.$getInfo('11')
    },
    async getResouseListData(){
      // 资源推荐
       const data = await this.$getList(19);
       this.resouseList = data.splice(0, 4)
    },
    // 案例
    async getCaseList(){
      const data = await this.$getCateList(8);
      const list = await this.$getList(data[0] && data[0].id);
      this.caseList = list.splice(0, 6)
    },
    // 精选文章
    async getSelected(){
      const data = await this.$getList();
      this.selectLeft = data[0]
      this.selectData = data.splice(1, 3)
    },
    search() {
      if (!this.keyWord) {
        return;
      }
      const keyWordList = window.localStorage.getItem('keyWordList') ? JSON.parse(window.localStorage.getItem('keyWordList')) : [];
      if (keyWordList.findIndex(item => item === this.keyWord) > -1) {
        keyWordList.splice(keyWordList.findIndex(item => item === this.keyWord), 1);
      }
      keyWordList.unshift(this.keyWord);
      if (keyWordList.length > 6) {
        keyWordList.pop();
      }
      this.keyWordList = keyWordList;
      window.localStorage.setItem('keyWordList', JSON.stringify(keyWordList));
      // this.$axios({
      //   url:'/search',
      //   method: 'get'
      // }).then(res => {
      //   console.log(res);
      // })
      this.$router.push({ path: '/case', query: { keyWord: this.keyWord } });
    },
    searchTag(item) {
      this.keyWord = item;
      this.search();
    },
    getEchartsData(){
      this.$axios({
        url:'/index/home_data',
        method: 'post'
      }).then(res => {
        this.echartsData = res.data.content;
        // this.options.xAxis[0].data = res.data.year;
        // this.options.series[0].data = res.data.user;
        // this.options.series[1].data = res.data.increase;
        // const max = res.data.user[res.data.user.length - 1] > res.data.increase[res.data.increase.length - 1] ? res.data.user[res.data.user.length - 1] : res.data.increase[res.data.increase.length - 1];
        // this.options.yAxis[0].max = max;
        // this.echartsInit()
      })
    }
  },
}

</script>
<style scoped lang="scss">
.home {
  width: 100%;
  height: 100%;

  .searchBox {
    width: 100%;
    height: 880px;
    background: url("../assets/banner.png") no-repeat center center;
    background-size: cover;
    font-family: Microsoft YaHei, Microsoft YaHei;
    overflow: hidden;
    text-shadow: 0px 4px 15px rgba(0, 0, 0, 0.65);

    .title {
      margin-top: 168px;
      font-weight: bold;
      font-size: 120px;
      color: #F3F5F8;
      line-height: 141px;
      text-align: center;
    }

    .sub_title {
      font-weight: 400;
      font-size: 60px;
      color: #FFFFFF;
      line-height: 70px;
      text-align: center;
    }

    .name {
      background: #246CF9;
      border-radius: 140px 140px 140px 140px;
      margin: 40px auto 0;
      padding: 14px 30px;
      width: fit-content;
      font-weight: 400;
      font-size: 27px;
      color: #FFFFFF;
      cursor: default;
    }

    .searchInput {
      margin: 157px auto 0;
      max-width: 1120px;

      ::v-deep .el-input-group__append {
        background: #246CF9;
        color: #FFF;
        height: 56px;
        box-shadow: none;
        padding: 0 40px;
      }

      ::v-deep .el-button {
        display: flex;
        align-items: center;
      }

      ::v-deep .el-input-group {
        height: 56px;
      }

      ::v-deep .el-input__wrapper.is-focus {
        box-shadow: none;
      }
    }

    .searchTagBox {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .item {
        padding: 5px 10px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px 4px 4px 4px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        margin-right: 20px;
        cursor: pointer;
      }
    }
  }

  .contentBox {
    background:  no-repeat center center;
    background-size: cover;
    padding: 80px 0;

    .topTitle {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 50px;
      color: #333333;
      line-height: 59px;
      text-align: center;
      margin-bottom: 40px;
    }

    .data_item {
      margin: 0 auto;
      max-width: 1200px;
      margin-bottom: 60px;
    }

    .dataStatic {
      p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 21px;
        text-indent: 2em;
      }

      .echartsBox {
        margin-top: 50px;
        // height: 450px;
      }
    }

    .articleBox {
      display: flex;
      max-width: 1200px;
      margin: 0 auto;

      .left {
        width: 540px;
        cursor: pointer;

        .img {
          width: 100%;
          height: 304px;
        }

        .title {
          margin: 20px 0 20px 16px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
        }
      }

      .right {
        margin-left: 20px;
        flex: 1;

        .item {
          padding-bottom: 16px;
          margin-bottom: 16px;
          border-bottom: 1px solid #CCCCCC;
          display: flex;
          cursor: pointer;

          &:last-child {
            border: none;
          }

          .image {
            width: 150px;
            height: 100px;
            margin-right: 20px;
          }

          .titleBox {
            display: flex;
            align-items: center;

            .tag {
              width: fit-content;
              padding: 2px 8px;
              border-radius: 2px 2px 2px 2px;
              background: #246CF9;
              font-size: 12px;
              color: #FFFFFF;
              margin-right: 10px;
            }

            .title {
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: 15px;
              color: #333333;
            }
          }

          .infoBox {
            margin: 10px 0;
            display: flex;
            align-items: center;

            .date,
            .number {
              display: flex;
              align-items: center;

              .icon {
                margin-right: 5px;
              }

              font-size: 12px;
              color: #666666;
            }

            .number {
              margin-left: 20px;
            }
          }

          .content {
            font-size: 12px;
            color: #666666;
            line-height: 22px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
          }
        }
      }
    }

    .resourceBox {
      .resourceContent {
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;

        .item {
          background: #FFFFFF;
          box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
          padding: 20px;
          margin-bottom: 20px;
          display: flex;
          cursor: pointer;

          .image {
            width: 240px;
            height: 135px;
            margin-right: 20px;

            .banner {
              width: 100%;
              height: 100%;
            }
          }

          .content {
            .title {
              font-size: 18px;
              color: #333333;
            }

            .number {
              margin-top: 45px;
              font-size: 14px;
              color: #666666;
            }

            .date {
              font-size: 14px;
              color: #666666;
              margin-top: 10px;
            }
          }
        }
      }
    }

    .practiceBox {
      .practiceContent {
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;

        .item {
          background: #FFFFFF;
          margin-bottom: 30px;
          cursor: pointer;
          .image {
            width: 100%;
            height: 214px;
          }

          .content {
            padding: 20px;

            .title {
              font-weight: 400;
              font-size: 20px;
              color: #333333;
              line-height: 23px;
            }

            .date {
              margin-top: 20px;
              font-size: 16px;
              color: #666666;
              line-height: 19px;
            }
          }
        }
      }
    }
  }
}
</style>
